import React,{ Component } from 'react'
import ProductoOpcion from '../components/producto_opcion_mod'


const ProductoOpciones = (props) => {
      if(! props.producto.opciones){
        return <div>CARGANDO</div>
      }
      const opciones = props.producto.opciones

      function ponesaca(item, cantidad){
        props.opcionAct(item, cantidad)
      }

      function cambiaGaleria(galeria){
        props.imgAct(galeria)
      }

      const  listaOpciones = opciones.map((opcion,i)=>{
          return <ProductoOpcion key={i} opcion={opcion} opcionAct = { ponesaca } imgAct = { cambiaGaleria } prodUnidad = {props.producto.unicad.cant}/>
      })

		  return (
        <section className="col-md-8  float-left">
          { listaOpciones !=null  &&
                listaOpciones 
          }
        </section>
		  )
}

export default ProductoOpciones




// WEBPACK FOOTER //
// ./src/components/producto_opciones.js